document.addEventListener("DOMContentLoaded", () => {
  const allInputs = document.querySelectorAll(".quantity-input");
  const addToCartBtn = document.getElementById("add-to-cart-btn");

  function toggleAddToCartButton() {
    const hasValidQuantity = Array.from(allInputs).some(
      (input) => parseInt(input.value, 10) > 0
    );
    addToCartBtn.disabled = !hasValidQuantity; // Enable button if any quantity > 0
  }

  // Add event listeners to each input for quantity changes
  allInputs.forEach((input) => {
    input.addEventListener("input", toggleAddToCartButton); // Trigger on input change
  });

  // Initialize the button state on page load
  toggleAddToCartButton();
});

// UpdateQuantity function with an additional trigger for button state
function updateQuantity(variantId, change) {
  const inputField = document.getElementById(`quantity_${variantId}`);
  let currentValue = parseInt(inputField.value, 10);
  if (isNaN(currentValue)) currentValue = 0;

  const newValue = currentValue + change;
  if (newValue >= 0) {
    inputField.value = newValue;
    inputField.dispatchEvent(new Event("input")); // Trigger input event for button state
  }
}

function customAddToCart() {
  const allInputs = document.querySelectorAll(".quantity-input");
  const itemsToAdd = [];
  const addToCartBtn = document.getElementById("add-to-cart-btn");
  const spinner = addToCartBtn.querySelector(".loading__spinner");

  // Disable button and show loading spinner
  addToCartBtn.disabled = true;
  addToCartBtn.classList.add("loading");
  if (spinner) {
    spinner.classList.remove("hidden");
  } else {
    console.log("Spinner not found");
  }

  // Collect all variants with quantity > 0
  allInputs.forEach((input) => {
    const variantId = input.id.split("_")[1];
    const quantity = parseInt(input.value, 10);

    if (quantity > 0) {
      itemsToAdd.push({ id: variantId, quantity });
    }
  });

  // Send a single request with all variants
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ items: itemsToAdd }), // Use the "items" array for batch add
  })
    .then((response) => {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error("Failed to add items to the cart.");
      }
    })
    .then((data) => {
      let notification = document.getElementById("cart-notification");
      notification.classList.add("animate", "active");
      // Update cart counter
      updateCartCounter();
    })
    .catch((error) => {
      console.error("Error updating cart:", error);
      alert("An error occurred while adding items to the cart.");
    })
    .finally(() => {
      addToCartBtn.classList.remove("loading");
      if (spinner) spinner.classList.add("hidden");
    });
  allInputs.forEach((input) => {
    input.value = 0;
  });
}

function updateCartCounter() {
  fetch("/cart.js", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then((cart) => {
      const cartCount = cart.item_count;
      const cartCounterElement = document.querySelector(".cart-count-bubble");
      if (cartCounterElement) {
        cartCounterElement.textContent = cartCount;
        cartCounterElement.classList.toggle("hidden", cartCount === 0);
      } else {
        console.log("No buuble found");
      }
    })
    .catch((error) => {
      console.error("Error fetching cart data:", error);
    });
}
